import React from "react";
import {Box, Stack, Text} from "@chakra-ui/core";

import {useTranslation} from "~/i18n/hooks";
import { Plan } from "~/types/plans";
import Heading from "~/ui/display/Heading";
import { formatTranslationText } from "~/utils/formatTranslations";
import TranslationsFormatText from "~/components/TranslationsFormatText";

interface Props {
  plan: Plan;
}

const PlanCard: React.FC<Props> = ({ plan }) => {
  const t = useTranslation();
  

  return (
      <Stack marginBottom={{base: '2.5rem', md: '0'}} backgroundColor="white" borderRadius="lg" boxShadow="xl" padding={8} paddingBottom={8} spacing={4} width={"330px"}>
        <Heading fontSize={{base: "2xl", md: "3xl"}} color={plan.color}>
          {t(plan.title)}
        </Heading>
        <Box>
          {formatTranslationText(t(plan.description)).map((line: string) => {
            return <TranslationsFormatText line={line} key={line} color="gray.600" fontSize="md" />
          })}
        </Box>
        <Stack spacing={0}>
          <Text fontSize="sm" fontWeight="bold" textTransform="uppercase">
            {t("plans.priceFrom")}
          </Text>
          <Heading color="primary.900" fontSize={{base: "4xl", md: "5xl"}}>
            ${plan.price}*
          </Heading>
          <Text color="gray.400" fontSize="sm" paddingTop='0.5rem'>
            *{t(plan.extraInfo)}
          </Text>
        </Stack>
      </Stack>
  );
};

export default PlanCard;
